<template>
  <svg
    class="background d-none d-md-block"
    xmlns="http://www.w3.org/2000/svg"
    width="930"
    height="802"
  >
    <defs>
      <linearGradient id="a" x1="57.358%" x2="0%" y1="81.915%" y2="0%">
        <stop offset="0%" stop-color="#2780E3" />
        <stop offset="100%" stop-color="#f1f4fc" />
        <!-- <stop offset="0%" stop-color="#2780E3"/><stop offset="100%" stop-color="#2780E3"/> -->
      </linearGradient>
    </defs>
    <path
      fill-rule="evenodd"
      fill="#FD6592"
      d="M.014 0s67.224 121.256 292.378 105.496c131.289-14.82-8.891 192.843 113.577 237.084 122.469 37.434 208.038-13.613 283.382 137.259C764.694 630.71 683.728 676.085 930 802V0H.014z"
    />
    <path
      fill="url(#a)"
      d="M.014 0s67.224 121.256 292.378 105.496c131.289-14.82-8.891 192.843 113.577 237.084 122.469 37.434 208.038-13.613 283.382 137.259C764.694 630.71 683.728 676.085 930 802V0H.014z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
svg.background {
  position: absolute;
  top: 0;
  right: 0;
  height: 804px;
  z-index: -1;
}
</style>
